import { useFormik } from 'formik';
import * as Yup from 'yup';
import { CorporateAccountOpenProfileDetailsPages, useCorporateAccountOpenProfileDetailsPageTypeStore } from 'views/pages/accountOpenProfileDetails/corporateProfileDetails/hooks';
import { useEffect } from 'react';
import { useCorporateAccountEstablishStore } from '../hooks';
import { ErrorWord, TemplateProps } from '../common';
import { formErrorScroll } from 'views/mutual/formErrorScroll';
import { useGlobalToastHandler } from 'views/mutual/globalToast/hooks';

export enum AuthModeSelectType {
  None = 0,
  SMS = 1,
  MailAddress = 2,
}

export type TFAuthenticationType = {
  authMode: AuthModeSelectType;
};

export const useTFAuthentication = ({ isUpdate }: TemplateProps) => {
  const { param, add } = useCorporateAccountEstablishStore();
  const { setAccountOpenProfileDetailsPageType } = useCorporateAccountOpenProfileDetailsPageTypeStore();
  const { messageClose } = useGlobalToastHandler();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const validation = Yup.object().shape({
    authMode: Yup.number().not([AuthModeSelectType.None], ErrorWord.SELECT),
  });

  const initialValues: TFAuthenticationType = {
    authMode: param.authMode ?? AuthModeSelectType.None,
  };

  const formik = useFormik<TFAuthenticationType>({
    enableReinitialize: isUpdate,
    initialValues,
    async onSubmit() {
      add({
        ...param,
        ...formik.values,
      });
      setAccountOpenProfileDetailsPageType(CorporateAccountOpenProfileDetailsPages.entryConfirm);
    },
    validationSchema: validation,
    validateOnChange: false,
    validateOnBlur: false,
    validate: () => {
      // バリデーションかける時に必ずエラートーストを閉じる
      messageClose();
    },
  });

  const authModeProps = {
    selected: formik.values.authMode,
    onChange: (value: AuthModeSelectType) => {        
      formik.setFieldValue('authMode', value);
    },
    error: formik.errors.authMode,
  };

  useEffect(() => {
    formErrorScroll();
  }, [formik.isSubmitting]);

  return {
    formik,
    authModeProps,
  };
};
